import { render } from "./ButtonCircle.vue?vue&type=template&id=7f674686"
import script from "./ButtonCircle.vue?vue&type=script&lang=js"
export * from "./ButtonCircle.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__